@if (bookConfig && bookConfig.otherEditions && bookConfig.otherEditions.length > 0) {
    <div class="edition-switcher-btn-row"
    >
        <div class="dropdown edition-switcher-dropdown">
            <button aria-expanded="true"
                    aria-haspopup="true" class="btn btn-sm btn-block btn-round btn-open btn-inverse btn-semibold dropdown-toggle" data-bs-toggle="dropdown" data-bs-display="static" id="otherEditions"
                    type="button">
                Auflage {{ bookConfig.editionNum }}/{{ bookConfig.editionYear }} <i class="fas fa-caret-down"></i>
            </button>
            <ul aria-labelledby="otherEditions" class="dropdown-menu dropdown-menu-end">
                @for (edition of bookConfig.otherEditions; track edition; let i = $index) {
                    <li>
                        <a class="dropdown-item" href="{{ edition.link }}">Auflage {{ edition.editionNum }}/{{ edition.editionYear }}</a>
                    </li>
                }
            </ul>
        </div>
    </div>
}